export const scormTraining = (
    phrases,
    assignmentId,
    testId,
    fieldSystem,
    isCompatibleBrowserTest,
    asyncScorm,
    setiFrameShow,
    closeRTE,
    closeRTEAsync,
    completeCalls
) => {
    let dateInit = new Date();
    let statusSCO = "";
    let exitSCO = "";
    let callFinish = false;
    let callConfirnExit = false;
    let responseExit = "";
    let bScormComplete = false;
    let bScormReturn = false;
    let isChrome = false;
    var apiPhrase = phrases["1002168"];

    let RequestObject = {
        assignmentId: assignmentId,
        trainingId: testId,
    };

    let API_XPERT = {
        version: "1.0", // mandatory version attribute

        // SCO RTE functions
        LMSInitialize: function () {
            statusSCO = "";
            exitSCO = "";
            let ret;
            let resp;

            ret = asyncScorm("lmsInitialize", RequestObject, true);

            if (ret !== null) {
                resp = ret.scormValue;
            }

            return resp;
        },

        LMSFinish: async function () {
            setiFrameShow(false);
            let resp;

            isChrome = isCompatibleBrowserTest(fieldSystem);

            if (!isChrome) {
                //continue as is

                if (!callFinish) {
                    let now = new Date();
                    let durationTime = Math.round(
                        (now.getTime() - dateInit.getTime()) / 1000
                    ).toString();
                    let host = window.location.hostname;
                    let domain = "xpert.adeccogroup.com";
                    if (host != null && host != "") {
                        let prefix = host.indexOf(".");
                        domain = host.substring(prefix + 1, host.length);
                    }

                    resp = await completeCalls("exitSCO", RequestObject, true);

                    if (resp !== null) {
                        exitSCO = resp.scormValue;
                    }

                    resp = await completeCalls("statusSCO", RequestObject, true);

                    if (resp !== null) {
                        statusSCO = resp.scormValue;
                    }

                    let ret;
                    let isCompleted = "false";
                    callFinish = true;
                    if (bScormComplete) {
                        isCompleted = "true";
                    } else if (
                        !callConfirnExit &&
                        fieldSystem == "37" &&
                        !bScormReturn &&
                        confirm(apiPhrase)
                    ) {
                        isCompleted = "true";
                    } else {
                        if (fieldSystem != "37") {
                            isCompleted = "true";
                        } else if (!callConfirnExit && fieldSystem == "37") {
                            exitSCO = "logout";
                        } else if (fieldSystem == "37") {
                            if (responseExit == "Y") {
                                isCompleted = "true";
                            } else if (responseExit == "N") {
                                exitSCO = "logout";
                            }
                        }
                    }

                    RequestObject.durationTime = durationTime;
                    RequestObject.domain = domain;
                    RequestObject.completed = isCompleted;
                    RequestObject.fieldSystem = fieldSystem;

                    resp = await completeCalls("lmsFinish", RequestObject, true);
                }

                await closeRTE(exitSCO, statusSCO, RequestObject);

                return "true";
            } else {
                //handle chrome block async issue
                /* jshint ignore:start */
                (async function (dataobject) {
                    if (!callFinish) {
                        let now = new Date();
                        let durationTime = Math.round(
                            (now.getTime() - dateInit.getTime()) / 1000
                        ).toString();
                        let host = window.location.hostname;
                        let domain = "xpert.adeccogroup.com";
                        if (host != null && host != "") {
                            let prefix = host.indexOf(".");
                            domain = host.substring(prefix + 1, host.length);
                        }
                        let resp = await fetch("/rest/scormtraining/exitSCO", {
                            method: "POST",
                            headers: {
                                "x-xpert-session": dataobject.assignmentId,
                                "Content-Type":
                                    "application/json; charset=utf-8",
                            },
                            body: JSON.stringify(dataobject),
                        });
                        let respjson = await resp.json();
                        if (respjson !== null) {
                            exitSCO = respjson.scormValue;
                        }

                        resp = await fetch("/rest/scormtraining/statusSCO", {
                            method: "POST",
                            headers: {
                                "x-xpert-session": dataobject.assignmentId,
                                "Content-Type":
                                    "application/json; charset=utf-8",
                            },
                            body: JSON.stringify(dataobject),
                        });
                        respjson = await resp.json();
                        if (respjson !== null) {
                            statusSCO = respjson.scormValue;
                        }

                        let ret;
                        let isCompleted = "false";
                        callFinish = true;
                        if (bScormComplete) {
                            isCompleted = "true";
                        } else if (
                            !callConfirnExit &&
                            fieldSystem == "37" &&
                            !bScormReturn &&
                            confirm(apiPhrase)
                        ) {
                            isCompleted = "true";
                        } else {
                            if (fieldSystem != "37") {
                                isCompleted = "true";
                            } else if (
                                !callConfirnExit &&
                                fieldSystem == "37"
                            ) {
                                exitSCO = "logout";
                            } else if (fieldSystem == "37") {
                                if (responseExit == "Y") {
                                    isCompleted = "true";
                                } else if (responseExit == "N") {
                                    exitSCO = "logout";
                                }
                            }
                        }

                        RequestObject.durationTime = durationTime;
                        RequestObject.domain = domain;
                        RequestObject.completed = isCompleted;
                        RequestObject.fieldSystem = fieldSystem;

                        resp = await fetch("/rest/scormtraining/lmsFinish", {
                            method: "POST",
                            headers: {
                                "x-xpert-session": dataobject.assignmentId,
                                "Content-Type":
                                    "application/json; charset=utf-8",
                            },
                            body: JSON.stringify(dataobject),
                        });
                    }

                    await closeRTEAsync(exitSCO, statusSCO, RequestObject);

                    return "true";
                })(RequestObject);
                /* jshint ignore:end */
                return "true";
            }
        },

        LMSGetValue: function (name) {
            RequestObject.element = name;

            let response = asyncScorm("lmsGetValue", RequestObject, true);

            if (response != null) {
                return response.scormValue;
            }
        },

        LMSSetValue: function (name, value) {
            RequestObject.element = name;
            RequestObject.value = value;

            let response = asyncScorm("lmsSetValue", RequestObject, true);

            if (response != null) {
                return response.scormValue;
            }
        },

        LMSCommit: function () {
            isChrome = isCompatibleBrowserTest(fieldSystem);
            if (!isChrome) {
                //continue as is
                let response = asyncScorm("lmsCommit", RequestObject, true);

                if (response != null) {
                    return response.scormValue;
                }
            } else {
                //handle chrome block async issue
                /* jshint ignore:start */
                (async function (dataobject) {
                    let resp = await fetch("/rest/scormtraining/lmsCommit", {
                        method: "POST",
                        headers: {
                            "x-xpert-session": dataobject.assignmentId,
                            "Content-Type": "application/json; charset=utf-8",
                        },
                        body: JSON.stringify(dataobject),
                    });
                    let respjson = await resp.json();
                    if (respjson != null) {
                        ret = respjson.scormValue;
                    }
                })(RequestObject);
                /* jshint ignore:end */
                return true;
            }
        },

        LMSGetDiagnostic: function (errCode) {
            RequestObject.errorCode = errCode;

            let response = asyncScorm("lmsGetDiagnostic", RequestObject, true);

            if (response != null) {
                return response.scormValue;
            }
        },

        LMSGetErrorString: function (errCode) {
            RequestObject.errorCode = errCode;

            let response = asyncScorm("lmsGetErrorString", RequestObject, true);

            if (response != null) {
                return response.scormValue;
            }
        },

        LMSGetLastError: function () {
            let response = asyncScorm("lmsGetLastError", RequestObject, true);

            if (response != null) {
                return response.scormValue;
            }
        },
    };
    return API_XPERT;
};
